import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import '../../styles/Login.css';
import LogoSVG from './utils/logo.svg';
import { useTranslation } from 'react-i18next';

export default function LoginLayout(props: any) {
    const { t } = useTranslation()
    return (
        <Container 
            maxWidth="md"
            sx={{ 
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                px: { xs: 2, sm: 4 },
            }}
        >
            <Card 
                sx={{ 
                    width: '100%',
                    borderRadius: 4,
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(16px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    overflow: 'hidden',
                }}
            >
                <CardContent sx={{ p: 0, pb: '0 !important' }}>
                    <Grid 
                        container
                        direction={{ xs: 'column', md: 'row' }}
                        sx={{ minHeight: { xs: 'auto', md: 500 } }}
                    >
                        <Grid 
                            item
                            xs={12}
                            md={5}
                            sx={{
                                background: 'linear-gradient(145deg, #003a8d 0%, #351f98 100%)',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                py: { xs: 4, md: 0 },
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: -50,
                                    right: -50,
                                    width: 200,
                                    height: 200,
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #93dbee, #cb5daa)',
                                    opacity: 0.1,
                                }}
                            />
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: -30,
                                    left: -30,
                                    width: 120,
                                    height: 120,
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #93dbee, #cb5daa)',
                                    opacity: 0.15,
                                }}
                            />
                            
                            <Box sx={{ textAlign: 'center', zIndex: 1, px: { xs: 2, md: 0 } }}>
                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        background: '#a1a1a1',
                                        filter: 'brightness(1.7)',
                                        borderRadius: 2,
                                        p: 1,
                                        backdropFilter: 'blur(10px)',
                                        mb: 1
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={LogoSVG}
                                        alt="USEP"
                                        sx={{ width: { xs: 120, md: 175 } }}
                                    />
                                </Box>

                                <Typography 
                                    variant="h2" 
                                    sx={{
                                        fontFamily: "'Inter', sans-serif",
                                        fontWeight: 700,
                                        fontSize: { xs: '2rem', md: '3rem' },
                                        background: 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        letterSpacing: '-0.025em',
                                        mb: 0.5
                                    }}
                                >
                                    US<span style={{ color: '#93dbee' }}>E</span>P
                                </Typography>
                                <Typography 
                                    variant="body1" 
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontWeight: 500,
                                        letterSpacing: '0.05em',
                                        textTransform: 'uppercase',
                                        fontSize: '0.825rem'
                                    }}
                                >
                                    {t('translations:LOG_IN_DESCRIPTION')}
                                </Typography>
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 3,
                                        background: 'linear-gradient(90deg, #cb5daa, #93dbee)',
                                        borderRadius: 2,
                                        mx: 'auto',
                                        mt: 3
                                    }}
                                />
                            </Box>
                        </Grid>
                        
                        <Grid item xs={12} md={7}>
                            <Box 
                                sx={{ 
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    background: 'rgba(255, 255, 255, 0.95)',
                                    backdropFilter: 'blur(10px)',
                                    px: { xs: 2, md: 6 },
                                    py: { xs: 4, md: 0 }
                                }}
                            >
                                <Box>
                                    {props.children}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    );
}